/** @module ProductSpec/SizeChart/SubrangeIncrementRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
], function(declare, Ref) {

	return declare(Ref, {
		tagAction: "ActionIncrement",

		/**
		 * @overwrite
		 * Prevent requiring tooltip in ProductGroup popup views
		 */
		headingToTooltip: function(ctx, h, tooltip) {
			if (ctx.defView.getId() == "ProductGroup") {
				return null;
			} else {
				return this.inherited(arguments);
			}
		}

	});
});